import { render } from "./GameRecommendationsChoosePage.vue?vue&type=template&id=e59f6d4a&scoped=true"
import script from "./GameRecommendationsChoosePage.vue?vue&type=script&lang=js"
export * from "./GameRecommendationsChoosePage.vue?vue&type=script&lang=js"

import "./GameRecommendationsChoosePage.vue?vue&type=style&index=0&id=e59f6d4a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59f6d4a"]])

export default __exports__